<!-- 新建工单 -->
<template>
	<div>
		<el-dialog title="新建工单" :visible.sync="dialogVisible" :close-on-click-modal="false" v-el-drag-dialog width="40%"
			@close="changeClose">
			<div v-loading="loading">
				<el-form :model="form" label-width="120px" :rules="rules" ref="form" class="box-form">
					<el-form-item label="问题系统" prop="questionSystemId">
						<div class="question-list">
							<div :class="[
                'question-item',
                questionActive == index ? 'item-active' : '',
              ]" v-for="(item, index) in systemList" :key="'sys' + item.questionSystemId"
								@click="switchQuestion(item.questionSystemId, index)">
								{{ item.questionContent }}
							</div>
						</div>
					</el-form-item>
					<el-form-item label="详细问题" prop="sheetQuestions" v-if="dialogVisible">
						<div v-for="(item, index) in form.sheetQuestions" :key="index" :class="{ mt20: index != 0 }">
							<div class="flex" style="align-items: flex-start;">
								<div style="flex: 1">
									<el-input type="textarea" :autosize="{ minRows: 5}" v-model="item.questions"
										placeholder="请输入具体问题描述">
									</el-input>
									<upload-file :list.sync="item.questionsFile" ref="upload"></upload-file>
								</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="期望完成时间" prop="hopeCompleteTime">
						<el-date-picker v-model="form.hopeCompleteTime" type="date" :picker-options="pickerOptions"
							value-format="yyyy-MM-dd" placeholder="请选择期望完成时间" style="width: 100%">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="联系人" prop="contactUserName">
						<el-input v-model="form.contactUserName" placeholder="请输入联系人"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="contactTel">
						<el-input v-model="form.contactTel" placeholder="请输入联系电话"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="more-que" v-if="!loading && isShowAddBtn" @click="submit({ isReset: '1' })">
							<i class="el-icon-plus"></i> 提交并创建新工单
						</div>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer">
				<el-button :loading="loading" @click="dialogVisible = false">取 消</el-button>
				<el-button :loading="loading" type="primary" plain @click="submit({ type: '0' })" v-if="showDraft">存为草稿
				</el-button>
				<el-button :loading="loading" type="primary" plain @click="submit({ type: '2' })" v-if="showEditDraft">
					修改草稿
				</el-button>
				<el-button :loading="loading" v-if="isShowAddBtn" type="primary" @click="submit({ type: '1' })">提交
				</el-button>
			</span>
		</el-dialog>

		<!-- 图片查看器 -->
		<el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="viewerUrl" style="z-index: 9999" />
	</div>
</template>

<script>
	import UploadFile from '@/components/Common/UploadFile.vue'
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

	/**
	 * @params
	 * showDraft: 是否显示加入草稿按钮
	 * showDraft: 是否显示修改草稿按钮
	 */

	export default {
		props: {
			showDraft: {
				type: Boolean,
				default: true
			},
			showEditDraft: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				dialogVisible: false,
				questionActive: 0, // 当前选择问题系统下标
				// 添加工单
				form: {
					contactTel: '',
					contactUserName: '',
					questionSystemId: '',
					hopeCompleteTime: '',
					sheetQuestions: [{
						questions: '',
						questionsFile: []
					}]
				},
				rules: {
					contactTel: {
						required: true,
						message: '请输入联系电话',
						trigger: 'blur'
					},
					contactUserName: {
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					},
					questionSystemId: {
						required: true,
						message: '请选择问题系统',
						trigger: 'change'
					},
					hopeCompleteTime: {
						required: true,
						message: '请选择期望完成时间',
						trigger: 'change'
					},
					sheetQuestions: {
						required: true,
						message: '请添加详细问题',
						trigger: 'change'
					}
				},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 3600 * 1000 * 24
					}
				},

				sheetDraftId: '', // 当前草稿id

				loading: false,

				systemList: [], // 问题系统列表
				showViewer: false, // 显示查看器
				viewerUrl: [] // 查看器图片数组
			}
		},
		components: {
			UploadFile,
			ElImageViewer
		},
		computed: {
			userInfo() {
				return this.$store.state.user.userInfo || {}
			},
			// 服务是否已延期
			isShowAddBtn() {
				let showAddBtn = sessionStorage.getItem('endDay');
				if (showAddBtn && Number(showAddBtn) < 0) {
					return false;
				} else {
					return true;
				}
			}
		},
		watch: {
			'form.sheetQuestions': {
				handler(v) {
					if (v && v.length > 0) {
						this.$nextTick(() => {
							this.$refs.form.clearValidate('sheetQuestions')
						})
					}
				},
				deep: true
			}
		},
		mounted() {},
		methods: {
			open(data) {
				if (data) {
					const copyData = JSON.parse(JSON.stringify(data))
					this.sheetDraftId = copyData.sheetDraftId
					for (const k in copyData) {
						if (copyData[k]) this.form[k] = copyData[k]
					}
				} else {
					this.form.contactUserName = this.userInfo.nickname
					this.form.contactTel = this.userInfo.tel
				}
				this.dialogVisible = true
				this.getSystemList()
			},

			// 选择问题系统
			switchQuestion(id, index) {
				this.questionActive = index
				this.form.questionSystemId = id
			},

			// 添加工单
			submit({
				isReset,
				type
			}) {
				this.$refs.form.validate((valid) => {
					if (valid) {
						for (let i = 0; i < this.form.sheetQuestions.length; i++) {
							const item = this.form.sheetQuestions[i]
							if (!item.questions) {
								this.$notify.error({
									title: '提示',
									message: '具体问题描述不能为空'
								})
								return
							}
						}
						this.loading = true
						// 0 草稿 1 发布 2 修改草稿
						let httpType = ''
						let httpParams = this.form
						switch (type) {
							case '0':
								httpType = 'sheetDraftAdd'
								break
							case '1':
								httpType = 'sheetAdd'
								break
							case '2':
								httpType = 'sheetDraftEdit'
								httpParams = {
									...httpParams,
									sheetDraftId: this.sheetDraftId
								}
								break
							default:
								break
						}
						this.$api.order[httpType](httpParams)
							.then(({
								data
							}) => {
								if (data.code == 200) {
									this.$notify.success({
										title: '提示',
										message: type === '0' ? '已存为草稿' : '提交成功'
									})
									this.$emit('refresh', type)
									this.dialogVisible = false
									if (isReset === '1') {
										this.changeClose()
										setTimeout(() => {
											this.dialogVisible = true
										}, 500)
									}
								}
							})
							.finally(() => {
								this.loading = false
							})
					} else return false
				})
			},

			// 添加工单表单弹窗关闭 重置
			changeClose() {
				this.$refs.form.resetFields()
				// eslint-disable-next-line no-unused-expressions
				this.$refs.upload?.forEach((item) => {
					item.clearFiles()
				})
				this.form.sheetQuestions = [{
					questions: '',
					questionsFile: []
				}]
				this.questionActive = 0
			},

			// 获取问题系统列表
			getSystemList() {
				this.$api.order.questionSystemList().then(({
					data
				}) => {
					if (data.code == 200) {
						this.systemList = data.data
						this.form.questionSystemId = this.systemList[0].questionSystemId
					}
				})
			},

			// 查看文件
			viewFile(item) {
				const url = item.fileUrl
				if (item.fileType == '0') {
					this.viewerUrl = [url]
					this.showViewer = true
				} else {
					window.open(url)
				}
			},

			// 关闭查看器
			closeViewer() {
				this.showViewer = false
			}
		}
	}
</script>

<style lang='scss' scoped>
	.box-form {
		max-height: 50vh;
		padding-right: 10px;
		overflow: auto;

		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 10px;
			background: rgba(0, 0, 0, 0.2);
		}

		&::-webkit-scrollbar-track {
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}
	}

	.popover-title {
		width: 70px;
		color: #409eff;

		&:hover {
			text-decoration: underline;
			cursor: pointer;
		}
	}

	.popover-file {
		margin-bottom: 10px;
		color: #999;

		&:hover {
			text-decoration: underline;
			cursor: pointer;
		}
	}

	.question-list {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.question-item {
			height: 30px;
			padding: 0 10px;
			margin: 5px 5px 0 0;
			background: #f0f2f5;
			color: #909399;
			border-radius: 4px;
			font-size: 12px;
			line-height: 30px;
			cursor: pointer;
		}

		.item-active {
			background: linear-gradient(90deg, #3682ff, #4d9fff);
			color: #fff;
		}
	}

	.more-que {
		/* margin-top: 20px; */
		padding: 10px 0;
		background-color: #f4f4f4;
		text-align: center;
		color: #999;
		border-radius: 4px;
		cursor: pointer;
	}
</style>
